import { render, staticRenderFns } from "./z_auxiliary_box.vue?vue&type=template&id=618f15d8&scoped=true"
import script from "./z_auxiliary_box.vue?vue&type=script&lang=js"
export * from "./z_auxiliary_box.vue?vue&type=script&lang=js"
import style0 from "./z_auxiliary_box.vue?vue&type=style&index=0&id=618f15d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f15d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618f15d8')) {
      api.createRecord('618f15d8', component.options)
    } else {
      api.reload('618f15d8', component.options)
    }
    module.hot.accept("./z_auxiliary_box.vue?vue&type=template&id=618f15d8&scoped=true", function () {
      api.rerender('618f15d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/z_auxiliary_box.vue"
export default component.exports